import { Routes, BrowserRouter, Route, Navigate } from 'react-router-dom'
import RouteConfig from './route-config'
import { createBrowserHistory } from 'history'
import { Route as CustomRoute } from './route'
import Home from '../containers/Home'

export const history = createBrowserHistory()

const AppRouter = () => {
    return (
        <BrowserRouter basename="/">
            <Routes>
                {RouteConfig.map((route: CustomRoute, i: number) => {
                    const RouteComponent = route.component
                    return (
                        <Route
                            key={i}
                            path={route.path}
                            children={route.children}
                            element={<RouteComponent {...route?.props} />}
                        />
                    )
                })}
                <Route index element={<Home />} />
            </Routes>
        </BrowserRouter>
    )
}

export default AppRouter
